import { createRouteDefintion, type RouteDefinition } from "./RouteDefinition";
import type { RouteTemplate } from "./RouteTemplate";

export type RedirectRouteDefinition<RouteParameters> = { isRedirect: true; routeDefinition: RouteDefinition<RouteParameters, []> };

// We want to avoid redirects where possible.
// Instead of linking to redirects, can you instead link directly to the page that the redirect would otherwise take you to?
// If you are looking to add a redirect for a route that has since been changed, see `allLegacyRoutes` instead.
export function createRedirect<RouteParameters>(relativeTemplate: RouteTemplate<RouteParameters>): RedirectRouteDefinition<RouteParameters> {
    const routeDefinition: RouteDefinition<RouteParameters, []> = createRouteDefintion({
        // This absoluteTemplate starts relative and will be completed by route segments adding prefixes later on
        absoluteTemplate: relativeTemplate,
        relativeTemplate: relativeTemplate,
        queryParameters: [],
    });

    return {
        routeDefinition,
        isRedirect: true,
    };
}
